import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        const { data } = await axios.post(`${BASE_URL}/user/token`, {
          refreshToken,
        });

        localStorage.setItem("accessToken", data.accessToken);
        axiosInstance.defaults.headers.common["Authorization"] =
          data.accessToken;

        originalRequest.headers["Authorization"] = data.accessToken;
        return axiosInstance(originalRequest);
      } catch (err) {
        console.error("Refresh token error:", err);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");

        alert("세션이 만료되었습니다. 다시 로그인해주세요.");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

const fileInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

fileInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        const { data } = await axios.post(`${BASE_URL}/user/token`, {
          refreshToken,
        });

        localStorage.setItem("accessToken", data.accessToken);
        axiosInstance.defaults.headers.common["Authorization"] =
          data.accessToken;

        originalRequest.headers["Authorization"] = data.accessToken;
        return axiosInstance(originalRequest);
      } catch (err) {
        console.error("Refresh token error:", err);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");

        alert("세션이 만료되었습니다. 다시 로그인해주세요.");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export { axiosInstance, fileInstance };
